export default "__VITE_ASSET__066dc323__"